import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { readUser } from "../utils/perm";

export default function RequireMaster({ children }) {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  const userData =
    localStorage.getItem("userData") || sessionStorage.getItem("userData");
  const location = useLocation();
  const role = readUser()?.rolename?.roleName;

  if (!token || !userData) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (role !== "MASTER") {
    return <Navigate to="/404" replace />;
  }
  return children;
}
